var _jsxFileName = "/codebuild/output/src449691236/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/TopHeaderBackArrow/index.tsx";
import React from 'react';
import { IconBack } from '@adc/parallax-component-library';
const TopHeaderBackArrow = ({
  testID
}) => {
  return /*#__PURE__*/React.createElement(IconBack, {
    color: "$neutral.100",
    testID: testID,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6,
      columnNumber: 10
    }
  });
};
export { TopHeaderBackArrow };